import { render, staticRenderFns } from "./ModalSubstitutionArticle.vue?vue&type=template&id=170d47f4&"
import script from "./ModalSubstitutionArticle.vue?vue&type=script&lang=js&"
export * from "./ModalSubstitutionArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('170d47f4')) {
      api.createRecord('170d47f4', component.options)
    } else {
      api.reload('170d47f4', component.options)
    }
    module.hot.accept("./ModalSubstitutionArticle.vue?vue&type=template&id=170d47f4&", function () {
      api.rerender('170d47f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Divers/ModalSubstitutionArticle.vue"
export default component.exports